export default {
    'memberBundleMgr.selectAddressHasServiceTips': "The current address does not provide TM service"
}